import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import {
  GetBatteryWithTestsDto,
  GetTestDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';

interface BatteryProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
}

export const batteryForGrid = (battery: GetBatteryWithTestsDto) => {
  const totalSeconds = battery.testsDto
    ? (battery.testsDto as unknown as GetTestDto[]).reduce(
        (sum, t) => sum + (t.averageDuration ?? 0),
        0,
      )
    : 0;
  const totalMinutes =
    totalSeconds > 0 ? `${Math.round(totalSeconds / 60)} min` : '';

  return {
    key: battery.id,
    values: {
      'battery.name': battery.name,
      'battery.description': battery.description,
      'battery.count': battery.testsDto ? battery.testsDto.length : 0,
      'battery.tests': battery.testsDto
        ? battery.testsDto
            .map(t => (t as unknown as GetTestDto).name)
            .join(', ')
        : '',
      'battery.online': battery?.testsDto?.some(
        t => !(t as unknown as GetTestDto).onlineOption,
      )
        ? 'NIE'
        : 'TAK',
      'battery.avgDuration': totalMinutes,
    },
  };
};

export const Battery: React.FC<BatteryProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'battery.name' },
    { header: 'Opis', property: 'battery.description' },
    { header: 'Liczba testów', property: 'battery.count', noSorting: true },
    { header: 'Wybrane testy', property: 'battery.tests', noSorting: true },
    {
      header: 'Śr. czas trwania',
      property: 'battery.avgDuration',
      noSorting: true,
      noFilter: true,
    },
    {
      header: 'Online',
      property: 'battery.online',
      noSorting: true,
      noFilter: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="battery.name"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak baterii testów w systemie"
      refresh={props.refresh}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
      showExport={true}
    />
  );
};
